import React from 'react';
import { useSelector } from "react-redux";

import { BaseUser, UserState } from "@/reducers/currentUserReducer";
import { RootState } from "@/reducers/rootReducer";


const getColor = (user: BaseUser) => {
  const str = `${user.firstName} ${user.lastName}`;

  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = "#";
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.substr(-2);
  }
  return color;
};

const getInitials = ({ firstName, lastName }: BaseUser) => {
  const firstInitial = (firstName && firstName[0].toUpperCase()) || "";
  const lastInitial = (lastName && lastName[0].toUpperCase()) || "";

  return firstInitial + lastInitial || "?";
};

interface UserAvatarProps {
  height?: number;
  width?: number;
}

interface AvatarProps extends UserAvatarProps {
  user?: BaseUser;
  height?: number;
  width?: number;
}

export const Avatar = ({
  user,
  height: h = 100,
  width: w,
}: AvatarProps) => {
  const height: number = h;
  const width: number = w ?? h;

  if (!user) {
    return null;
  }

  if (user?.avatarURL) {
    return (
      <div className='rounded' style={{ width, height }}>
        <img alt="avatar" className='rounded' src={user.avatarURL} {...{ height, width }} />
      </div>
    );
  } else {
    return (
      <div className='flex items-center justify-center rounded-full'
        style={{ backgroundColor: getColor(user), height, width }}
      >
        <span className='text-white font-bold text-lg'>{getInitials(user)}</span>
      </div>
    );
  }
};

export const UserAvatar = (props: UserAvatarProps) => {
  const { attributes } = useSelector<RootState, UserState>((state) => state.user);

  return <Avatar user={attributes} {...props} />;
};

